import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export type SafeOverallStatus = {
  convertedSafeHolders: number;
  safeHolders: number;
  totalConvertedInvestment: number;
  totalConvertedShares: number;
  totalPendingInvestment: number;
};

export const useSafeOverallStatus = ({ companyId }: { companyId: string }) => {
  const queryClient = useQueryClient();

  const { data: overallStatus, isLoading } = useAppQuery<SafeOverallStatus>({
    queryKey: [QueryKey.GET_SAFE_OVERALL_STATUS, companyId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'safes', 'company-overall-status'],
      }),
    enabled: !!companyId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SAFE_OVERALL_STATUS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    overallStatus,
    isLoading,
  };
};
